export const SELECT_ROOM = 'SELECT_ROOM';
export const SET_ROOMS = 'SET_ROOMS';
export const SET_ROOM = 'SET_ROOM';
export const SET_ROOM_INFO = 'SET_ROOM_INFO';
export const SET_FLOOR = 'SET_FLOOR';
export const SET_SNACKBAR = 'SET_SNACKBAR';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER = 'SET_USER';
export const SET_USER_ROOM = 'SET_USER_ROOM';
export const REMOVE_USER_ROOM = 'REMOVE_USER_ROOM';
export const REMOVE_USER_ROOMMATE = 'REMOVE_USER_ROOMMATE';
export const SET_VIEW = 'SET_VIEW';
export const SET_ARTICLES = 'SET_ARTICLES';

export const SET_OPEN = 'SET_OPEN';

export const SET_PERIOD = 'SET_PERIOD';
export const SET_ALLOWED_ROOMS = 'SET_ALLOWED_ROOMS';
export const SET_ALLOWED_USERS = 'SET_ALLOWED_USERS';
export const SET_RESERVATIONS = 'SET_RESERVATIONS';
export const SET_UPCOMING = 'SET_UPCOMING';

export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const POP_NOTIFICATION = 'POP_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_NOTIFICATION_TIMEOUT = 'SET_NOTIFICATION_TIMEOUT';
